import { render, staticRenderFns } from "./PasswordChangeComponent.vue?vue&type=template&id=690045c9&scoped=true"
import script from "./PasswordChangeComponent.vue?vue&type=script&lang=js"
export * from "./PasswordChangeComponent.vue?vue&type=script&lang=js"
import style0 from "./PasswordChangeComponent.vue?vue&type=style&index=0&id=690045c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690045c9",
  null
  
)

export default component.exports